import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { useTranslation } from 'react-i18next';

interface Props {
    label?: string;
    onClick: () => void;
}

const useStyles = makeStyles((theme: any) => ({
    button: {
        appearance: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.25rem',
        alignSelf: 'flex-start',
        padding: 0,
        marginBottom: '0.75rem',
        border: 'none',
        background: 'none',
        fontFamily: 'inherit',
        color: theme.palette.common.darkGrey,
        cursor: 'pointer',
        '&:focus-visible': {
            outline: `2px solid ${theme.palette.common.darkGrey}`,
            outlineOffset: '2px',
        },
    },
    icon: {
        fontSize: '1.25rem',
        marginLeft: '-0.25rem',
    },
    label: {
        fontSize: '1rem',
        textTransform: 'none',
    },
}));

export const SearchBackButton = ({ label, onClick }: Props) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <button type="button" className={classes.button} onClick={onClick} data-testid="search-go-back-btn">
            <ChevronLeftIcon className={classes.icon} />
            <Typography component="span" className={classes.label}>
                {label || t('GoBack')}
            </Typography>
        </button>
    );
};
